import "@rdc-npm/rdc-static/minified/css/rdc-lite-cube-swap.static.min.css";
import { RdcAppShell } from "@rdc-npm/rdc-app-shell";
import { getFeatureFlagProps, initializeFeatureFlags } from "@rdc-npm/rdc-app-context";
import { getDeviceType, getVisitorId } from "@rdc-npm/rdc-utils";
import NextApp from "next/app";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import withReduxStore from "../lib/with-redux-store";
import { Provider } from "react-redux";
import { reportWebVitalsToNewRelic } from "../util/reportWebVitalsToNewRelic";
import { Context as ResponsiveContext } from "react-responsive";
import "../static/css/styles.css";
import { useTrackCWV } from "../util/trackCWV";
import { config } from "api/config";
import { useEffect, useState } from "react";
import FeatureFlagsInitializer from "components/LandingPage/FeatureFlagsInitializer";

const ModalContainer = dynamic(() => import("../containers/modules/ModalContainer"), {
  ssr: false,
});

const MyApp = ({ Component, pageProps, reduxStore, env = {}, appShellInitialProps }) => {
  const [innerWidth, setInnerWidth] = useState(1440);

  const appShellProps = { ...appShellInitialProps, env };
  let isDotRealtor =
    pageProps.query && pageProps.query.isDotRealtor && JSON.parse(pageProps.query.isDotRealtor)
      ? true
      : false;
  useTrackCWV();
  useEffect(() => {
    setInnerWidth(window.innerWidth);
  }, []);

  return (
    <>
      <div data-testid="component-mainLayout" className="mainLayout">
        <div className={isDotRealtor ? null : "globalNavWrapper"}>
          <RdcAppShell {...appShellProps}>
            {/* <UserContextProvider env='production' user={{ initialState: { savedSearches }}}> */}
            <Provider store={reduxStore}>
              <FeatureFlagsInitializer />
              <ResponsiveContext.Provider value={{ width: innerWidth }}>
                <Component {...pageProps} />
                <ModalContainer></ModalContainer>
              </ResponsiveContext.Provider>
            </Provider>
            {/* </UserContextProvider> */}
          </RdcAppShell>
        </div>
      </div>
    </>
  );
};

MyApp.getInitialProps = async (appContext) => {
  const { ctx } = appContext;
  const { req, res, query } = ctx;
  const isServer = req && res;
  let userAgent;
  let visitorId = "Everyone";
  const isDotRealtor = query && query.isDotRealtor && JSON.parse(query.isDotRealtor) ? true : false;
  if (isServer) {
    userAgent = ctx.req.headers["user-agent"];
    visitorId = getVisitorId(req.headers.cookie);
    await initializeFeatureFlags({
      enableHoldouts: true,
      timeout: config.DATAFILETIMEOUT,
      project: "RDCX",
      env: isDotRealtor ? "development" : config.ENVIRONMENT,
      userId: res.locals?.vst,
      ctx,
      logger: null,
      amplitudeApiKey: config.AMPLITUDE_API_KEY,
      deploymentKey: config.AMPLITUDE_DEPLOYMENT_KEY,
    });
  } else {
    userAgent = navigator.userAgent;
    visitorId = getVisitorId(document.cookie);
  }

  const deviceType = getDeviceType(userAgent);
  const appProps = await NextApp.getInitialProps(appContext);
  const isPromotedLDP =
    query && query.origin_source === "ldp_promote" && deviceType === "mobile" ? true : false;

  return {
    ...appProps,
    pageProps: { ...appProps.pageProps, deviceType, userAgent },
    appShellInitialProps: {
      appContextProps: {
        featureFlagProps: { ...getFeatureFlagProps(ctx) },
        env: isDotRealtor ? "development" : config.ENVIRONMENT,
      },
      hideHeader: isDotRealtor || isPromotedLDP,
      hideFooter: isDotRealtor,
      hideMobileBanner: true,
      headerProps: {
        activeTab: 5,
      },
      footerProps: {
        condense: ["Products", "News Corp"],
      },
      env: isDotRealtor ? "development" : config.ENVIRONMENT,
      pageName: appProps.pageProps?.pageName,
    },
    visitorId,
    queryParams: query,
    env: isDotRealtor ? "development" : config.ENVIRONMENT,
  };
};
export const reportWebVitals = reportWebVitalsToNewRelic;
MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object,
  appShellInitialProps: PropTypes.object,
  reduxStore: PropTypes.object,
  env: PropTypes.string,
};
export default withReduxStore(MyApp);
